<script setup>
const services = [
  {
    name: "Reparación de Fugas",
  },
  {
    name: "Desatascos y Destape de Tuberías",
  },
  {
    name: "Instalación de Tuberías y Accesorios",
  },
  {
    name: "Reparación de Sistemas Sépticos",
  },
  {
    name: "Mantenimiento Preventivo",
  },
  {
    name: "Reparación y Reemplazo de Calentadores de Agua",
  },
  {
    name: "Instalación de Sistemas de Fontanería",
  },
  {
    name: "Reparación de Grifos y Válvulas",
  },
];

const testimonials = [
  {
    name: "Franklin G.",
    message:
      "Increíble servicio de Plomeros a tu Alcance. Resolvieron mi problema de fontanería de manera rápida y eficiente. ¡Profesionales altamente recomendados!",
  },
  {
    name: "Vanessa J.",
    message:
      "¡Excelente experiencia con Plomeros a tu Alcance! Respondieron a mi llamada de emergencia rápidamente y solucionaron el problema con gran habilidad. ¡Confiables y eficientes!",
  },
  {
    name: "Raul S.",
    message:
      "Plomeros a tu Alcance realmente cumplió con mis expectativas. Su atención personalizada y el trabajo detallado en mi instalación fueron impresionantes. ¡Un servicio de fontanería de primera",
  },
  {
    name: "Marcos F.",
    message:
      "Nunca había tenido una experiencia tan positiva con un servicio de fontanería. Plomeros a tu Alcance demostró ser confiable, transparente y con un equipo altamente profesional. ¡Definitivamente mi elección para futuras necesidades!",
  },
  {
    name: "Carmen L.",
    message:
      "Gracias a Plomeros a tu Alcance por su rápida respuesta y solución a mi problema de tuberías. Fueron amables, eficientes y realmente se preocuparon por mi tranquilidad. ¡Altamente satisfecho con su servicio!",
  },
];
</script>

<template>
  <div class="home">
    <MainComponent sectionName="home" />

    <div class="container-fluid">
      <section>
        <div class="row justify-content-center">
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 col-xxl-10 text-center"
          >
            <h1 class="fw-bold my-5">
              “Tu tranquilidad, nuestra prioridad, Plomeros a tu Alcance, a un
              click de distancia en toda Venezuela”
            </h1>
          </div>
        </div>
      </section>
      <section>
        <div class="bg-easy-green py-6">
          <div class="row justify-content-center">
            <div
              class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 col-xxl-10 mb-5"
            >
              <p class="text-size-32 text-white text-center">
                Nuestro equipo altamente especializado se dedica a ofrecer
                servicios de fontanería de la más alta calidad para tu comodidad
                en todo el territorio venezolano. En Plomeros a tu Alcance, nos
                destacamos por:
              </p>
            </div>
          </div>
          <div class="row mx-2 justify-content-center">
            <!-- FIRST ELEMENT -->
            <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4">
              <div class="bg-full-dark rounded-4 py-4 my-3">
                <div class="text-center">
                  <img
                    src="../assets/images/home/card_icon.png"
                    class="border border-white border-2 w-50 rounded-circle"
                    alt="logo"
                  />
                </div>
                <div>
                  <h3
                    class="fw-bold text-white text-center py-4 border-4 border-bottom border-white"
                  >
                    Puntualidad y Confianza
                  </h3>
                </div>
                <div>
                  <p class="text-white my-3 text-size-20 mx-3">
                    La puntualidad es un valor fundamental en Plomeros a tu
                    Alcance. Cumplimos con nuestros compromisos y horarios,
                    brindándote la tranquilidad de saber que estamos aquí para
                    solucionar tus problemas de fontanería de manera oportuna.
                  </p>
                </div>
              </div>
            </div>

            <!-- SECOND ELEMENT -->
            <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4">
              <div class="bg-full-dark rounded-4 py-4 my-3">
                <div class="text-center">
                  <img
                    src="../assets/images/home/card_icon.png"
                    class="border border-white border-2 w-50 rounded-circle"
                    alt="logo"
                  />
                </div>
                <div>
                  <h3
                    class="fw-bold text-white text-center py-4 border-4 border-bottom border-white"
                  >
                    Tecnología de Vanguardia
                  </h3>
                </div>
                <div>
                  <p class="text-white my-3 text-size-20 mx-3">
                    Nos destacamos por estar a la vanguardia de la tecnología en
                    fontanería. En Plomeros a tu Alcance, utilizamos
                    herramientas y equipos de última generación para
                    diagnósticos precisos y soluciones innovadoras.
                  </p>
                </div>
              </div>
            </div>

            <!-- THIRD ELEMENT -->
            <div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 col-xxl-4">
              <div class="bg-full-dark rounded-4 py-4 my-3">
                <div class="text-center">
                  <img
                    src="../assets/images/home/card_icon.png"
                    class="border border-white border-2 w-50 rounded-circle"
                    alt="logo"
                  />
                </div>
                <div>
                  <h3
                    class="fw-bold text-white text-center py-4 border-4 border-bottom border-white"
                  >
                    Atención Continua 24/7
                  </h3>
                </div>
                <div>
                  <p class="text-white my-3 text-size-20 mx-3">
                    En Plomeros a tu Alcance, entendemos que las emergencias de
                    fontanería no siguen un horario convencional. Por eso,
                    ofrecemos atención continua 24/7 días de la semana. No
                    importa cuándo surja el problema.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="row justify-content-center">
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 col-xxl-10 text-center"
          >
            <h2 class="fw-bold my-5 text-size-40">
              “Mientras algunos prometen, nosotros entregamos. Deja que Plomeros
              a tu Alcance sea tu elección innegable”
            </h2>
          </div>
        </div>
      </section>
      <section>
        <div class="bg-easy-green py-6">
          <div class="row">
            <div
              class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
            >
              <h3 class="text-size-32 fw-bold text-center text-white">
                ALGUNOS DE NUESTROS SERVICIOS
              </h3>
            </div>
          </div>
          <div class="row">
            <div
              class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 col-xxl-3"
              v-for="(service, index) in services"
              :key="index"
            >
              <div class="service-card my-6">
                <img
                  :src="
                    require('../assets/images/home/services/service_' +
                      (index + 1) +
                      '.jpg')
                  "
                  alt="service 1"
                  class="h-100 w-100 mx-auto d-block rounded"
                />
                <p class="text-size-28 fw-bold text-center text-white">
                  {{ service.name }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="row justify-content-center">
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 col-xxl-10 text-center"
          >
            <h2 class="fw-bold my-5 text-size-40">
              “Porque sabemos que, cuando se trata de excelencia, no hay
              competencia real”
            </h2>
          </div>
        </div>
      </section>
      <section>
        <div class="bg-easy-green py-6">
          <div class="row justify-content-center">
            <div
              class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-5"
            >
              <h3 class="my-auto fw-bold text-center text-size-32 text-white">
                TESTIMONIOS SOBRE NOSOTROS
              </h3>
            </div>
            <div class="col-12 col-sm-12 col-md-10 col-lg-8 col-xl-5 col-xxl-5">
              <carousel :autoplay="3500" :wrap-around="true">
                <slide v-for="(user, index) in testimonials" :key="index">
                  <div class="carousel__item py-4 px-4 bg-full-dark">
                    <div class="d-flex flex-row justify-content-center">
                      <div class="my-auto">
                        <h3
                          class="my-auto text-white fw-bold text-center text-size-32"
                        >
                          {{ user.name }}
                        </h3>
                      </div>
                    </div>
                    <div class="my-4 px-4 text-white text-size-22">
                      <p>
                        {{ user.message }}
                      </p>
                    </div>
                  </div>
                </slide>

                <template #addons>
                  <navigation class="text-white mx-4" />
                </template>
              </carousel>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="my-6">
          <div class="row">
            <div
              class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
            >
              <h3 class="text-size-32 fw-bold text-center">
                OBSERVA LOS ULTIMOS VIDEOS DE TRABAJOS REALIZADOS
              </h3>
            </div>
          </div>

          <div class="mt-5">
            <div class="row">
              <div
                class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 col-xxl-3 text-center"
                v-for="i in 4"
                :key="i"
              >
                <button class="btn" @click="openVideo(i)">
                  <div class="thumbs-wrapper shadow">
                    <img
                      :src="require(`../assets/media/thumbs/video_${i}.png`)"
                      alt="#"
                      class="w-100 h-100 rounded"
                    />
                  </div>
                </button>
                <FsLightbox
                  :toggler="toggleVideo(i)"
                  :sources="[require(`../assets/media/video_${i}.mp4`)]"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import MainComponent from "@/components/Main.vue";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import FsLightbox from "fslightbox-vue/v3";

export default {
  name: "HomeView",
  components: {
    MainComponent,
    Carousel,
    Slide,
    Navigation,
    FsLightbox,
  },
  methods: {
    openVideo(video) {
      if (video == 1) {
        this.video_1 = !this.video_1;
      }
      if (video == 2) {
        this.video_2 = !this.video_2;
      }
      if (video == 3) {
        this.video_3 = !this.video_3;
      }
      if (video == 4) {
        this.video_4 = !this.video_4;
      }
    },
    toggleVideo(video) {
      if (video == 1) {
        return this.video_1;
      }
      if (video == 2) {
        return this.video_2;
      }
      if (video == 3) {
        return this.video_3;
      }
      if (video == 4) {
        return this.video_4;
      }
    },
  },
  data() {
    return {
      video_1: false,
      video_2: false,
      video_3: false,
      video_4: false,
    };
  },
};
</script>
<style scoped>
.carousel__item {
  min-height: 200px;
  width: 100%;
  font-size: 20px;
  border-radius: 8px;
}

.carousel__slide {
  padding: 10px;
}

.carousel__prev,
.carousel__next {
  box-sizing: content-box;
  border: 5px solid white;
}
</style>
